import { Component, Input, OnInit, forwardRef } from "@angular/core";
import { US_SubHeader, EnumShareMode, SubGroup } from "../../api/models";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MatLegacyCheckboxChange as MatCheckboxChange } from "@angular/material/legacy-checkbox";

@Component({
  selector: "app-share-editor",
  templateUrl: "./share-editor.component.html",
  styleUrls: ["./share-editor.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ShareEditorComponent),
      multi: true,
    },
  ],
})
export class ShareEditorComponent implements ControlValueAccessor, OnInit {
  @Input()
  public set avaialbleSubscriptions(newSubscriptions: US_SubHeader[]) {
    this.value = {
      subscriptionShareStates: [],
    };

    this._availableSubscriptions = newSubscriptions;
    if (this._availableSubscriptions) {
      if (this._availableSubscriptions.length > 0) {
        this.selectedSubscription = this._availableSubscriptions[0];
      }
    }
  }

  @Input()
  public allowReadOnly = true;

  @Input()
  public allowModify = false;

  private _value: ShareState = {
    subscriptionShareStates: [],
  };

  public get value(): ShareState {
    return this._value;
  }

  public set value(val: ShareState) {
    this._value = val;
  }

  selectedSubscription: US_SubHeader = null;
  public _availableSubscriptions: US_SubHeader[] = [];

  changeFn: any = null;
  touchFn: any = null;

  constructor() {}

  ngOnInit(): void {}

  writeValue(obj: ShareState): void {
    this.value = obj;
    if (this.changeFn) {
      this.changeFn(this.value);
    }
  }

  registerOnChange(fn: any): void {
    this.changeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.touchFn = fn;
  }

  groupIsSelected(shareType: number, subscriptionGroupId: number): boolean {
    for (let i = 0; i < this.value?.subscriptionShareStates.length; i++) {
      const sub = this.value.subscriptionShareStates[i];
      if (sub.subscriptionId === this.selectedSubscription.subscriptionId) {
        for (let e = 0; e < sub.groupShareStates.length; e++) {
          const group = sub.groupShareStates[e];
          if (group.subscriptionGroupId === subscriptionGroupId) {
            if (shareType === 0) {
              return group.notShared;
            } else if (shareType === 1) {
              return group.readOnly;
            } else if (shareType === 2) {
              return group.allowModify;
            }
          }
        }
      }
    }

    if (shareType === 0) {
      return true;
    }

    return false;
  }

  groupCheckChanged(changeEvent: MatCheckboxChange) {
    const sourceItems = changeEvent.source.name.split("-");
    const subscriptionGroupId = parseInt(sourceItems[0]);
    const shareType = parseInt(sourceItems[1]);
    const checked = changeEvent.checked;

    if (!this.value) {
      this.value = {
        subscriptionShareStates: [],
      };
    }

    for (let i = 0; i < this.value.subscriptionShareStates.length; i++) {
      const sub = this.value.subscriptionShareStates[i];
      if (sub.subscriptionId === this.selectedSubscription.subscriptionId) {
        for (let e = 0; e < sub.groupShareStates.length; e++) {
          const group = sub.groupShareStates[e];
          if (group.subscriptionGroupId === subscriptionGroupId) {
            if (shareType === 0 && checked) {
              group.allowModify = false;
              group.readOnly = false;
              group.notShared = true;
              sub.groupShareStates.slice(e, 1);
              if (this.changeFn) {
                this.changeFn(this.value);
              }
              return;
            } else if (shareType === 1) {
              group.notShared = false;
              group.readOnly = true;
              group.allowModify = false;
              if (this.changeFn) {
                this.changeFn(this.value);
              }
              return;
            } else if (shareType === 2) {
              group.notShared = false;
              group.readOnly = false;
              group.allowModify = true;
              if (this.changeFn) {
                this.changeFn(this.value);
              }
              return;
            }
          }
        }

        const newGroupShare: GroupShareState = {
          subscriptionGroupId: subscriptionGroupId,
          notShared: shareType === 0,
          readOnly: shareType === 1,
          allowModify: shareType === 2,
        };

        sub.groupShareStates.push(newGroupShare);

        if (this.changeFn) {
          this.changeFn(this.value);
        }
        return;
      }
    }

    const newSubscriptionShareState: SubscriptionShareState = {
      subscriptionId: this.selectedSubscription.subscriptionId,
      groupShareStates: [
        {
          subscriptionGroupId: subscriptionGroupId,
          notShared: shareType === 0,
          readOnly: shareType === 1,
          allowModify: shareType === 2,
        },
      ],
    };

    this.value.subscriptionShareStates.push(newSubscriptionShareState);
    this.changeFn(this.value);
  }
}

export interface GroupShareState {
  notShared: boolean;
  readOnly: boolean;
  allowModify: boolean;
  subscriptionGroupId: number;
}

export interface SubscriptionShareState {
  subscriptionId: number;
  groupShareStates: GroupShareState[];
}

export interface ShareState {
  subscriptionShareStates: SubscriptionShareState[];
}
